/*******************************************************************
* PAGE        : buildSidebarMenu
* REMARKS     : Comman build Sidebar Menu Component
* CREATED ON  : 03-11-2025
* AUTHOR      : Bamroliya.Paras
* MODIFY      : Bamroliya.Paras
* MODIFY ON   : 05-03-2026
********************************************************************/

import { Images } from "../../utils/Images";

export function buildSidebarMenu(apiData) {

    // Remove duplicate FormId entries
    const uniqueData = Object.values(
        apiData.reduce((acc, item) => {
            if (!acc[item.FormId]) {
                acc[item.FormId] = item;
            }
            return acc;
        }, {})
    );

    const grouped = {};

    // Group by CMExpressAPISetupReferenceId
    uniqueData
        .filter(item => item.CMExpressAPISetupReferenceId !== 0)
        .forEach(item => {
            const key = item.CMExpressAPISetupReferenceId;

            if (!grouped[key]) {
                grouped[key] = [];
            }

            grouped[key].push(item);
        });

    const result = [];

    // Build menu
    Object.values(grouped).forEach(group => {

        const parentItem = group.find(item => !item.PageUrl);

        if (parentItem) {
            const parent = {
                name: parentItem.MenuCaption,
                link: null,
                icon: Images[parentItem.Icon] || Images.spaceDashboard,
                children: group
                    .filter(item => item.PageUrl)
                    .map(child => ({
                        name: child.MenuCaption,
                        link: child.PageUrl,
                        icon: Images[child.Icon] || Images.spaceDashboard
                    }))
            };

            result.push(parent);
        }
        else {
            group.forEach(item => {
                result.push({
                    name: item.MenuCaption,
                    link: item.PageUrl,
                    icon: Images[item.Icon] || Images.spaceDashboard
                });
            });
        }
    });

    return result;
}



//  return result.map(m => {
//         if (m.children.length === 0) delete m.children;
//         return m;
//     });

// {
//     "CMExpressAPIUserMasterId": 1,
//     "CMExpressAPIUserRightsId": 2,
//     "CMExpressAPISetupId": 10,
//     "FormId": 2902,
//     "BaseFormId": 365,
//     "PageUrl": "/complaints",
//     "MenuCaption": "Complaints",
//     "Icon": "pendingcomplaint",
//     "IsParent": true,
//     "IsAllowAdd": true,
//     "IsAllowEdit": true,
//     "IsAllowView": true,
//     "IsAllowDelete": true
// }